import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';

const WHAT_HAPPENS = [
  'It goes straight to their data protection team by email.',
  'They have one calendar month to reply. We track the deadline and remind them.',
  'If they ask for proof of who you are, you can upload your ID and we send it for you.',
];

/**
 * ReadyToSendCard
 * ---------------
 * The call to action for a draft request. If the organisation has an email
 * address we show the Send button and what happens next; otherwise we
 * point the user at the organisation's details to add one.
 */
const ReadyToSendCard = ({ sar, sending, onSend, onEditOrganisation }) => {
  const hasEmail = !!sar?.organisation_email;

  if (!hasEmail) {
    return (
      <section className="mb-4 rounded-lg bg-amber-wash px-6 py-5" data-testid="ready-to-send-no-email">
        <h2 className="text-[16px] font-semibold text-amber-ink">
          We need an email address for {sar?.organisation_name || 'this organisation'}
        </h2>
        <p className="mt-2 text-[15px] leading-[1.6] text-ink-70 max-w-[60ch]">
          The request is written. Add their data protection email address to the organisation and
          you can send it from here.
        </p>
        <div className="mt-4">
          <Button variant="secondary" onClick={onEditOrganisation}>
            Edit organisation
          </Button>
        </div>
      </section>
    );
  }

  return (
    <section className="mb-4 rounded-lg bg-ground px-6 py-5" data-testid="ready-to-send">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h2 className="text-[16px] font-semibold text-ink">Ready to send</h2>
          <p className="mt-2 text-[15px] leading-[1.6] text-ink-70 max-w-[60ch]">
            We will email this to
            <span className="pd-mono ml-1.5 text-ink normal-case">{sar.organisation_email}</span>
            {' '}and keep track of the reply.
          </p>
        </div>
        <Button onClick={onSend} disabled={sending} data-testid="send-email-btn" className="shrink-0">
          {sending && <Loader2 className="h-4 w-4 animate-spin" />}
          Send request
        </Button>
      </div>

      <div className="mt-5 border-t border-rule pt-4">
        <p className="pd-eyebrow mb-2">What happens when you send</p>
        <ol className="flex flex-col gap-1.5">
          {WHAT_HAPPENS.map((line, i) => (
            <li key={line} className="flex gap-3 text-[15px] leading-[1.6] text-ink-70">
              <span className="pd-mono mt-1 w-4 shrink-0 text-ink-55">{i + 1}</span>
              {line}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default ReadyToSendCard;
